import { ChevronDown, Youtube } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

const VIDEOS = [
  { label: 'Single piece', url: 'https://youtu.be/4qIYrc2iVOI' },
  { label: 'Multi piece', url: 'https://youtu.be/0PRntPCz4xs' },
];

/** The upload walkthrough, offered alongside the wizard's own tour: the tour
 * points at the current step, the video shows a whole project start to finish.
 * Opens in a new tab so it never navigates away from a draft in progress. */
export default function HowToUploadLink({ className }: { className?: string }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          title="Watch how to upload a project"
          className={cn(
            'gap-1.5 text-neutral-100 hover:bg-white/10 hover:text-green-300',
            className
          )}
        >
          <Youtube className="w-4 h-4 shrink-0 text-[#FF0000]" />
          How to upload
          <ChevronDown className="w-3.5 h-3.5 shrink-0 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {VIDEOS.map(({ label, url }) => (
          <DropdownMenuItem key={url} asChild className="cursor-pointer">
            <a href={url} target="_blank" rel="noopener noreferrer">
              <Youtube className="w-4 h-4 shrink-0 text-[#FF0000]" />
              {label}
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
